<form [formGroup]="formGroup()" class="row gap-md-0 gap-4">
  <div class="col-12 col-md-6">
    <div class="row gap-4">
      @if (showNameField) {
<!--         NAME-->
        <div class="col-sm-12">
          <app-form-input [id]="'name'"
                          [label]="'LOCATIONS.NAME' | translate"
                          [controlName]="'name'"
                          [formGroup]="formGroup()"/>
        </div>
      }
      <div class="col-sm-12">
        <app-form-select [id]="'country'"
                         [label]="('COUNTRY' | translate)"
                         [controlName]="'country'"
                         [formGroup]="getAddressFormGroup()"
                         [isRequired]="true"
                         [options]="countries"
                         [optionLabelSelector]="[{ selector: 'key' }]"
                         [optionValueSelector]="'value'"
                         ></app-form-select>
      </div>
      @if (showActiveStatus) {
      <!-- IS_ACTIVE -->
      <div class="col-sm-12">
        <app-checkbox-input [label]="'LOCATIONS.IS_ACTIVE'"
                            [id]="'active'"
                            [controlName]="'active'"
                            [formGroup]="formGroup()"
        />
      </div>
      }
    <!-- POSTCODE -->
        <div class="col-sm-12">
          <app-form-input [id]="'postcode'"
                          [label]="('POSTCODE' | translate)"
                          [controlName]="'postcode'"
                          [formGroup]="getAddressFormGroup()"
                          [isRequired]="true"/>
        </div>
      <!-- PLACE -->
        <div class="col-sm-12">
          <app-form-input [id]="'place'"
                          [label]="('PLACE' | translate)"
                          [controlName]="'place'"
                          [formGroup]="getAddressFormGroup()"
                          [isRequired]="true"/>
        </div>
      <!-- STREET -->
        <div class="col-sm-12">
          <app-form-input [id]="'street'"
                          [label]="('STREET' | translate)"
                          [controlName]="'street'"
                          [formGroup]="getAddressFormGroup()"
                          [isRequired]="true"/>
        </div>
      <!-- HOUSE NUMBER -->
        <div class="col-sm-12">
          <app-form-input [id]="'houseNumber'"
                          [label]="('HOUSE_NUMBER' | translate)"
                          [controlName]="'houseNumber'"
                          [formGroup]="getAddressFormGroup()"
                          [isRequired]="true"/>
        </div>
      <!-- ADDRESS SUFFIX -->
        <div class="col-sm-12">
          <app-form-input [id]="'addressSuffix'"
                          [label]="('ADDRESS_SUFFIX' | translate)"
                          [controlName]="'addressSuffix'"
                          [formGroup]="getAddressFormGroup()"/>
        </div>
    <!-- LATITUDE -->
      <div class="col-sm-12">
        <app-form-input [id]="'latitude'"
                        [label]="'LOCATIONS.LATITUDE' | translate"
                        [controlName]="'latitude'"
                        [formGroup]="formGroup()"
                        [isRequired]="true"
                        [type]="'number'"
                        [allowDecimalNumbers]="true"/>
      </div>
    <!-- LONGITUDE -->
      <div class="col-sm-12">
        <app-form-input [id]="'longitude'"
                        [label]="'LOCATIONS.LONGITUDE' | translate"
                        [controlName]="'longitude'"
                        [formGroup]="formGroup()"
                        [isRequired]="true"
                        [type]="'number'"
                        [allowDecimalNumbers]="true"/>
      </div>
    </div>
  </div>
  @if (mapReady) {
  <div class="col-12 col-md-6">
    <div class="row gap-4">
        <app-point-map
          [center]="{ lat: lat, lng: lng }"
          [zoom]="10"
          (addressSelected)="onAddressSelected($event)">
        </app-point-map>

    </div>
  </div>
  }
</form>
